export const PUBLIC_DOCUMENTS_PATHS = {
	datenschutz: {
		datenschutzHinweise: {
			name: 'Datenschutz-Hinweise',
			path: '/documents/datenschutz/Datenschutzhinweise_HA_Projektfoerderung.pdf',
		},
		allgemeineNebenBestimmung: {
			name: 'Allgemein-Nebenbestimmung',
			path: '/documents/datenschutz/ANBest_P_2023.pdf',
		},
	},
	antragsUnterlagen: {
		selbstErklaerungKMU: {
			name: 'Selbst Erklärung KMU',
			path: '/documents/antrag-unterlagen/KMU-Selbsterklärung-Berechnung.xlsx',
		},
		genehmigungEigentuemerLIS: {
			name: 'LIS Genehmigung Eigentümer',
			path: '/documents/antrag-unterlagen/LIS_Genehmigung_Eigentuemer_final.docx',
		},
		Stipendium: {
			KalkulationPersonalKosten: {
				KalkulationVorlageExcel: {
					name: 'push_Personalkostenkalkulation',
					path: '/documents/antrag-unterlagen/push_Personalkostenkalkulation.xlsx',
				},
			},
		},
		Loewe: {
			Projektuebersicht: {
				name: 'Liste_Foerderprojekte',
				path: '/documents/antrag-unterlagen/Liste_Foerderprojekte.docx',
			},
		},
	},
};
